import React from "react";
import Layout from "../components/layouts/layout";
import NewHomePage from "../components/NewHomePage";
import { BASE_SITE_URL } from "../shared/constants";

const seoData = {
  title: "Technology Consultancy & Software Development | Digiryte",
  ogtitle: "Technology Consultancy & Software Development | Digiryte",
  description:
    "Digiryte helps organisations consult, audit, build and scale digital products through technology advisory, AI, software engineering and cloud expertise.",
  ogimage: `${BASE_SITE_URL}/OGImage7.jpg`,
  ogurl: `${BASE_SITE_URL}/`,
};

const IndexPage = () => {
  return (
    <Layout seo={seoData} isIndexPage={true}>
      <NewHomePage />
    </Layout>
  );
};

export default IndexPage;
